// FormTimePicker.tsx
import * as React from "react";
import { Controller } from "react-hook-form";
import { TextField, Typography } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function FormTimePicker({
  control,
  fieldname,
  label,
  required = false,
  boldLabel,
  textColor,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={fieldname}
        control={control}
        rules={{ required: required ? "This field is required" : false }}
        render={({ field, fieldState }) => (
          <>
            {label && (
              <Typography
                variant="body1"
                fontWeight={boldLabel ? "bold" : "normal"}
                color={textColor || "inherit"}
              >
                {label} {required && <span style={{ color: "red" }}>*</span>}
              </Typography>
            )}
            <TimePicker
              // label={label}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => {
                if (newValue && newValue.isValid && newValue.isValid()) {
                  // Take today's date + selected time → save in ISO
                  const today = dayjs().startOf("day");
                  const finalDateTime = today
                    .hour(newValue.hour())
                    .minute(newValue.minute())
                    .second(newValue.second());

                  field.onChange(finalDateTime.toISOString());
                } else {
                  field.onChange(null);
                }
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: "small",
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message,
                },
              }}
            />
          </>
        )}
      />
    </LocalizationProvider>
  );
}
